module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_amber.76a07246.png";